// Делит число по разрядам
export default function numberWithSpaces(value) {
  return _.toString(value).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}
